var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandTiktokStyleBrand = function SvgBrandTiktokStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg_icon_BrandTiktokStyleBrand__svg5",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_icon_BrandTiktokStyleBrand__g5",
    fill: "none",
    transform: "matrix(.61538 0 0 .61538 1.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_BrandTiktokStyleBrand__path1",
    fill: "#00f2ea",
    d: "M14 15.599v-1.486A13 13 0 0 0 12.337 14C5.535 14 0 19.18 0 25.547 0 29.452 2.086 32.91 5.267 35c-2.13-2.132-3.315-4.942-3.313-7.861 0-6.276 5.377-11.394 12.046-11.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_BrandTiktokStyleBrand__path2",
    fill: "#00f2ea",
    d: "M14.327 32c2.876 0 5.221-2.273 5.328-5.107l.01-25.292h4.65A8.7 8.7 0 0 1 24.164 0h-6.35l-.011 25.293c-.106 2.832-2.453 5.105-5.328 5.105a5.3 5.3 0 0 1-2.476-.61A5.34 5.34 0 0 0 14.327 32m18.672-21.814V8.78a8.8 8.8 0 0 1-4.81-1.421A8.85 8.85 0 0 0 33 10.186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_BrandTiktokStyleBrand__path3",
    fill: "#ff004f",
    d: "M28 7.718A8.63 8.63 0 0 1 25.832 2h-1.697A8.74 8.74 0 0 0 28 7.718M12.325 20.065c-2.94.004-5.322 2.361-5.325 5.27A5.27 5.27 0 0 0 9.854 30a5.2 5.2 0 0 1-1.008-3.073c.003-2.91 2.385-5.268 5.325-5.271.55 0 1.075.09 1.572.244v-6.4a12 12 0 0 0-1.572-.114c-.092 0-.183.006-.274.007v4.916a5.3 5.3 0 0 0-1.572-.244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_BrandTiktokStyleBrand__path4",
    fill: "#ff004f",
    d: "M32.153 11v4.884a15.15 15.15 0 0 1-8.813-2.811V25.84c0 6.377-5.23 11.565-11.658 11.565-2.485 0-4.789-.778-6.682-2.097A11.67 11.67 0 0 0 13.528 39c6.429 0 11.659-5.188 11.659-11.564V14.668A15.15 15.15 0 0 0 34 17.478v-6.283A9 9 0 0 1 32.153 11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_BrandTiktokStyleBrand__path5",
    fill: "#fff",
    d: "M23.979 25.42V12.632A15.74 15.74 0 0 0 33 15.448v-4.89a9.1 9.1 0 0 1-4.912-2.82C26.016 6.431 24.586 4.358 24.132 2h-4.747l-.01 25.215c-.11 2.824-2.505 5.09-5.44 5.09-1.754-.002-3.398-.822-4.42-2.204-1.794-.913-2.919-2.716-2.92-4.682.003-2.92 2.44-5.285 5.45-5.289.56 0 1.098.09 1.608.245v-4.933C7.202 15.589 2 20.722 2 27.016c0 3.045 1.219 5.816 3.205 7.885A12.1 12.1 0 0 0 12.045 37c6.58 0 11.934-5.195 11.934-11.58"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandTiktokStyleBrand);
export { ForwardRef as ReactComponent };